import { render, staticRenderFns } from "./areaHumPassRate.vue?vue&type=template&id=22622480&scoped=true"
import script from "./areaHumPassRate.vue?vue&type=script&lang=js"
export * from "./areaHumPassRate.vue?vue&type=script&lang=js"
import style0 from "./areaHumPassRate.vue?vue&type=style&index=0&id=22622480&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22622480",
  null
  
)

export default component.exports